import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { throwError, catchError, retry, switchMap, from } from 'rxjs';
import { AuthService } from 'addiction-auth';
import { SugarAuthService } from '../auth/sugar-auth.service';

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const sugarAuth = inject(SugarAuthService);
    const retryReq = () =>
        req.clone({
            setHeaders: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + authService.idToken,
            },
        });
    return next(req).pipe(
        catchError((err) => {
            if (err.status === 401) {
                if (sugarAuth.isSugarIframe) {
                    // Nell'iframe non si fa refresh_token né logout/redirect: si rifà l'handshake
                    // con Sugar per token freschi, poi si ritenta la richiesta.
                    return from(sugarAuth.refresh()).pipe(switchMap(() => next(retryReq())));
                }
                //if 401 try first to refresh
                return authService.tryToRefreshToken().pipe(
                    switchMap(() => next(retryReq())),
                    catchError((err) => {
                        // auto logout if 401 response returned from api
                        authService.logout();
                        return throwError(() => new Error('unauthorized'));
                    })
                );
            }
            return throwError(() => err);
        }),
        retry({
            //prova un retry
            count: 1,
            delay: 500,
            resetOnSuccess: false, //non metterlo a true (non sappiamo bene il perchè ma va in loop)
        })
    );
};
